import { Link } from 'react-router-dom';
import MarketingHeader from '@/components/MarketingHeader';
import MarketingFooter from '@/components/MarketingFooter';
import '@/styles/milk-landing.css';

const SERIF = "'Instrument Serif', Georgia, serif";
const SANS = "'Work Sans', system-ui, sans-serif";

export const LegalSection = ({ id, title, children }) => (
  <section id={id} style={{ marginTop: 36 }} data-testid={`legal-section-${id}`}>
    <h2 style={{ fontFamily: SERIF, fontSize: 26, lineHeight: 1.15, color: '#212E40', margin: '0 0 12px' }}>{title}</h2>
    <div style={{ fontFamily: SANS, fontSize: 15.5, lineHeight: 1.75, color: '#3C4654' }}>{children}</div>
  </section>
);

export default function LegalLayout({ title, subtitle, updated, children }) {
  return (
    <div className="mlk-land" data-testid="legal-page">
      <MarketingHeader linkPrefix="/#" />

      {/* Content — landing container width, readable text column */}
      <main className="container" style={{ padding: '48px 28px 96px', fontFamily: SANS }}>
        <div style={{ maxWidth: 820 }}>
          <p style={{ fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8A93A0', margin: 0 }}>Legal</p>
          <h1 style={{ fontFamily: SERIF, fontSize: 48, lineHeight: 1.05, color: '#212E40', margin: '10px 0 8px' }}>{title}</h1>
          {subtitle && <p style={{ fontSize: 16, color: '#5A6675', margin: '0 0 6px', maxWidth: 620 }}>{subtitle}</p>}
          {updated && <p style={{ fontSize: 13, color: '#9A988F', margin: '12px 0 0' }}>Last updated: {updated}</p>}

          <div style={{ marginTop: 8 }}>{children}</div>

          {/* Footer cross-links */}
          <div style={{ marginTop: 56, paddingTop: 24, borderTop: '1px solid rgba(33,46,64,0.10)', display: 'flex', gap: 18, flexWrap: 'wrap', fontSize: 14 }}>
            <Link to="/privacy" data-testid="legal-footer-privacy" style={{ color: '#4C73A6', textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/terms" data-testid="legal-footer-terms" style={{ color: '#4C73A6', textDecoration: 'none' }}>Terms of Service</Link>
            <a href="mailto:privacy@addmilk.ai" style={{ color: '#4C73A6', textDecoration: 'none' }}>privacy@addmilk.ai</a>
          </div>
        </div>
      </main>

      <MarketingFooter linkPrefix="/#" />
    </div>
  );
}
